export class PickingListDeliveryEmployeeParams {
    page = 1;
    limit = 10;
    code?: string;
    status?: number;
    fromDate?: number;
    toDate?: number;
    targetRowGuid?: string;
}

export class PickingListDeliveryPartnerParams {
    page = 1;
    limit = 10;
    code?: string;
    status?: number;
    fromDate?: number;
    toDate?: number;
    targetRowGuid?: string;
}

export class HistoryStockOutParams {
    page = 1;
    limit = 10;
    pickingListType?: number;
    pickingListCode?: string;
    deliveryEmployeeRowGuid?: string;
    fromDate?: number;
    toDate?: number;
}
